module.exports = __webpack_public_path__ + "img/leadCancelled.64971067.svg";